<template>
  <div
    class="bannerBox"
    :style="{
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      padding: padding,
      position: 'relative',
      backgroundColor: '#2b333a',
      borderTop: '5px solid #587ab9',
    }"
  >
    <div class="carousel" v-if="showCarousel">
      <el-carousel style="height: 100%">
        <el-carousel-item v-for="(item, idx) in carouselList" :key="idx">
          <img :src="item.url" alt="" style="height: 100%; width: 100%" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="mainContent">
      <img :src="gif" width="200" height="200" style="position: absolute;right: 15px;z-index:9999">
      <div class="title1">
        <span>{{ title1 }}</span> 客服聊天助手 <span>基础功能 永久免费</span>
      </div>
      <div class="desc">电商客服必备工具 / 快捷回复 一键即达</div>
      <div class="desc">
        支持 Google Chrome 浏览器 / QQ / 微信 / 千牛 / 拼多多 / 抖店 /
        等众多聊天工具...
      </div>
      <div class="desc"><span>15</span> 万 客服工作者的选择 !</div>
      <div class="downloadBtn cursor-pointer inline-block" @click="toDownload">
        立即下载
      </div>
    </div>
  </div>
</template>
<script>
import bannerBg from "@/assets/imgs/home/bannerBg.png";
import bannerBg1 from "@/assets/imgs/price/priceBg.png";
import gif from "@/assets/imgs/replay/gif.gif";
import dataService from "@/service/data"
export default {
  props: {
    showCarousel: {
      type: Boolean,
      default: false,
    },
    bgSrc: String,
    title1: {
      type: String,
      default: "易回复",
    },
    title2: {
      type: String,
      default: "电商客服辅助翻译平台",
    },
    desc: {
      type: String,
      default: "专业、快捷、高效的翻译软件",
    },
    showDownload: {
      type: Boolean,
      default: true,
    },
    padding: {
      type: String,
      default: "4rem 0",
    },
  },
  data() {
    return {
      carouselList: [
        {
          url: bannerBg,
        },
        {
          url: bannerBg1,
        },
      ],
      gif,
      list: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      let data = await dataService.get("SOFT_REPLAY_DOWNLOAD_CONFIG");
      let value = JSON.parse(data.valued)
      this.list = value[0].child;
    },
    toDownload() {
      this.$emit("toDownload")
      // window.open(this.list[0].val, "_blank");
    },
  },
};
</script>
<style scoped>
.carousel {
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
}
.mainContent {
  position: relative;
  z-index: 999;
  color: #fff;
}
.title1,
.title2 {
  font-size: 2.5rem;
  text-align: left;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}
.title1 span:first-child {
  font-weight: bolder;
  color: #12c0ff;
  text-shadow: #000 2px 0 0, #000 0 2px 0, #000 -2px 0 0, #000 0 -2px 0;
}
.title1 span:last-child {
  background: #df0000;
  margin-bottom: 30px;
  font-size: 14px;
  padding: 0.15em 0.4em;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  text-shadow: #000 2px 0 0, #000 0 2px 0, #000 -2px 0 0, #000 0 -2px 0;
  display: inline-block;
}
.title2 {
  margin-top: 0.5rem;
}
.desc {
  text-align: left;
  font-size: 1.25rem;
  font-weight: 300;
  text-shadow: #000 2px 0 0, #000 0 2px 0, #000 -2px 0 0, #000 0 -2px 0;
  margin-bottom: 1rem;
}
.desc span {
  font-size: 50px;
    color: #ff5558;
    font-weight: bold;
    text-shadow: #000 2px 0 0, #000 0 2px 0, #000 -2px 0 0, #000 0 -2px 0;
}
.downloadBtn {
  line-height: 1.1875rem;
  text-align: center;
  background: linear-gradient(180deg, #5192fd 0%, #1d6ced 100%);
  padding: 0.875rem 1.75rem;
  border-radius: 0.5rem;
  color: var(--vt-c-white);
}
@media (max-width: 768px) {
}
</style>
<style>
.bannerBox .el-carousel__container {
  height: 100%;
}
.bannerBox .el-carousel__indicators--horizontal {
  bottom: 70px;
}
.bannerBox .el-carousel__indicator--horizontal button {
  height: 8px;
  width: 8px;
  border-radius: 16px;
  opacity: 1;
}

.bannerBox .el-carousel__indicator--horizontal.is-active button {
  background: #2470ef;
  width: 26px;
}
</style>